<template>
  <v-footer>
    <div class="text-right">
      <div class="overline">
        &copy; {{ new Date().getFullYear() }} KAMEOKA ELECTRONICS Co.,Ltd.
      </div>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: 'AppFooter',

  computed: {
    copyYear() {
      return new Date().getFullYear()
    }
  }
}
</script>
